/* eslint-disable angular/factory-name */

angular.
module("dx.webapp.masterTools").
factory("dxSearchIndexService", function searchIndexService(
	$http
) {
	"use strict";

	var indexType = Object.freeze({
		INDEX_STUDENTS: "students",
		INDEX_JOBS: "jobs",
	});

	function listIndices() {
		return $http.get("/search/index");
	}

	function createIndex(indexName) {
		return $http({
			method: "POST",
			url: "/search/index/" + indexName + "/create",
		});
	}

	function indexStatus(indexName) {
		return $http.get("/search/index/" + indexName + "/status");
	}

	function indexAllStudents() {
		return $http.post("/student/search/index/all");
	}

	function indexStudentsInOrg(nodeId) {
		return $http.post("/student/search/index/" + nodeId);
	}

	function indexAllJobs() {
		return $http.post("/api/v1/jobs/search/index");
	}

	function indexJobsInOrg(nodeId) {
		return $http.post("/api/v1/jobs/search/index/" + nodeId);
	}

	return {
		indexType: indexType,
		listIndices: listIndices,
		createIndex: createIndex,
		indexStatus: indexStatus,
		indexAllStudents: indexAllStudents,
		indexStudentsInOrg: indexStudentsInOrg,
		indexAllJobs: indexAllJobs,
		indexJobsInOrg: indexJobsInOrg,
	};
});
